import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withConfig from 'HOCs/withConfig/withConfig';
import { Link } from 'panamera-react-ui';
import css from './OlxAutosHeaderLight.desktop.scss';
import { CAR_DETAILS_CONSTANTS } from 'Constants/sellCarO2O';
import SITE_CODES from 'Constants/siteCodes';
import { getLogoData } from 'Components/HeaderWrapper/Headers/logoSizeHelper';
import withRouter from 'HOCs/withRouter';
import { compose } from 'redux';

export const OlxAutosHeaderLight = ({
    config,
    fullWidthHeader,
    isPaidCampaign,
    router,
    onClick = () => {}
}) => {
    const baseUrl = config.get('staticAssets');
    const theme = config.get('theme', 'id');
    const { logoUrl, logoWidth, logoHeight } = getLogoData(theme, true, baseUrl);
    const siteCode = config.get('siteCode');
    const logoAltText = config.get('logoAltText') ?? '';
    let landingPath
        = isPaidCampaign
        && [
            SITE_CODES.OLX_IN,
            SITE_CODES.OLX_ID,
            SITE_CODES.OLX_PE,
            SITE_CODES.OLX_EC
        ].includes(siteCode)
            ? CAR_DETAILS_CONSTANTS.AUTOS_VALUATION_ROUTE
            : CAR_DETAILS_CONSTANTS.VALUATION_CROSS_ROUTE;

    if (router?.location?.search) {
        landingPath = `${landingPath}${router?.location?.search}`;
    }

    return (
        <header className={ css.headerContainer }>
            <div
                className={ classnames(css.headerWrapper, {
                    [css.fullWidthHeader]: fullWidthHeader
                }) }
            >
                <div className={ css.header }>
                    <div className={ css.logo }>
                        <Link title={ logoAltText } to={ `/olxmobbi${landingPath}` } onClick={ onClick }>
                            <img src={ logoUrl } width={ logoWidth } height={ logoHeight } alt={ logoAltText } />
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    );
};

OlxAutosHeaderLight.propTypes = {
    fullWidthHeader: PropTypes.bool,
    isPaidCampaign: PropTypes.bool,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }),
    router: PropTypes.object,
    onClick: PropTypes.func
};

export default compose(withRouter, withConfig)(React.memo(OlxAutosHeaderLight));
